var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTruck = function SvgTruck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14787_497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5693 2.67529L56.9766 7.92334V10.4858H58.46V25.9888H56.9766V45.0122H58.46V60.5142H56.9766V70.3882L15.0234 70.3892V60.5142H13.541V45.0122H15.0234V25.9888H13.541V10.4858H15.0234V7.49072L15.3076 7.36084L25.5303 2.66748L25.6279 2.62354H46.4658L46.5693 2.67529Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14787_497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.01 -34.9531H-63.5723V150.198H403.01V-34.9531Z",
    stroke: "black",
    strokeWidth: 1.72997
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7937 10.5068H13.875V26.0104H58.7937V10.5068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7937 45.0332H13.875V60.5355H58.7937V45.0332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1111 7.99265L25.9801 3.43555H46.5113L56.6446 8.40106V69.7544H16.0273L16.1111 7.99265Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 24.8369H54.5856L53.9747 66.0063L53.4754 68.0063L51.3667 36.5679V33.3677H21.1081V36.3184L19.5228 68.5063L18.3419 67.0063L18.3398 24.8369Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8457 69.9224V7.82487L26.0691 3.13184H46.6847L56.8243 8.24446V69.9218L15.8457 69.9224Z",
    stroke: "black",
    strokeWidth: 0.975128
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4724 33.3113L19.2578 25.1729",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 69.67L21.4717 33.2715",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1738 33.2716L53.3884 25.1729",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4809 69.67L51.1738 33.2715",
    stroke: "black",
    strokeWidth: 0.487564
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4043 33.2666H51.3892",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1211 33.2305V70.0057",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7773 33.2305V69.9225",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.082 69.7418V25.0044H18.5879V70.275",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14787_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14787_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.4138,
    height: 72,
    fill: "white",
    transform: "translate(12.0332 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTruck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "truck.687d64750032d850abe73da0d61ed3a5.svg";